export default __webpack_public_path__ + "static/media/l1-p5.0f32cdfa.png";